// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"MerchantContractChannels_checkboxContainer__74RmN","loading":"MerchantContractChannels_loading__87KG9"};